import { async } from "@firebase/util";
import axios from "axios";
import { generateNumRandomId } from "../../components/common/GenerateRandomId/GenerateRandomId";
import { REFRESH_TOKEN } from "../../constants/localPath";
import refreshTokenWorker from "../../sagas/auth/refreshTokenSagas";
import { getLocalStoreString } from "../../utils/Helper";

export const axiosInstance = axios.create({
  headers: {
    accept: "application/json",
    "Tenant-Id": localStorage.getItem("CompanyID"),
  },
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const BearerToken = localStorage.getItem("BearerToken");
    // const EmployeeID = getLocalStoreString("EmployeeID");
    // const TenantId = getLocalStoreString("CompanyID");
    const TenantId = localStorage.getItem("CompanyID");
    const EmployeeID = localStorage.getItem("EmployeeId");
    const randomId = generateNumRandomId(8);
    config.headers["Authorization"] = `Bearer ${BearerToken}`;
    config.headers["Accept"] = "application/json";
    config.headers["Accrue-Client"] = "AdminPanel";
    config.headers["EmployeeID"] = EmployeeID;
    config.headers["Tenant-Id"] = TenantId;

    config.headers["employeeId"] = EmployeeID;
    config.headers["companyId"] = TenantId;
    config.headers["content_type"] = "image/png";
    config.headers["traceId"] = randomId;
    return config;
  },
  (error) => {
    return error;
  },
  (error) => Promise.reject(error)
);
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { status } = error.response;
    const token = localStorage.getItem(REFRESH_TOKEN);
    if (status === 401) {
      refreshTokenWorker(token);
    }
    return Promise.reject(error);
  }
);
